import { Box, Button, Container, Typography } from '@mui/material'
import React, { Component } from 'react'
import { useNavigate } from 'react-router-dom';
import FadeInSection from '../useInView';

const capabilityGroups = [
    {
        title: 'Web and App Development',
        items: ['Websites and web apps', 'Custom software', 'API integrations', 'React, Node.js'],
        target: 'target-1',
    },
    {
        title: 'IoT and Security Systems',
        items: ['IoT solutions', 'CCTV and access control', 'Network setup', 'Fire and Burglar Alarm Install'],
        target: 'target-1',
    },
    {
        title: 'Cloud and DevOps',
        items: ['Docker and deployments', 'CI/CD pipelines', 'Performance optimization', 'Scalable infrastructure'],
        target: 'target-1',
    },
    {
        title: 'Design and Branding',
        items: ['Brand identity', 'UI/UX design', 'Marketing assets', 'Adobe Creative Suite'],
        target: 'target-2',
    },
    {
        title: 'Media Production',
        items: ['Photo and video', 'Content production', 'Motion graphics', 'Event coverage'],
        target: 'target-3',
    },
    {
        title: 'Print and Fabrication',
        items: ['Commercial printing', '3D printing', 'Laser engraving', 'Signage and print assets'],
        href: 'https://printology.robotics-media.com',
    },
];

export function withRouter(Component) {
    return function WrapperComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
}

class TechComponent extends Component {
    handleNavigateAndScroll = (target) => {
        this.props.navigate('/services');
        setTimeout(() => {
            const element = document.getElementById(target);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 0);
    };

    handleCapabilityClick = (group) => {
        if (group.href) {
            window.open(group.href, '_blank', 'noreferrer');
            return;
        }
        if (group.target) {
            this.handleNavigateAndScroll(group.target);
        }
    };

    render() {
        return (
            <FadeInSection>
                <Container sx={{ height: '100%', width: '100%', backgroundColor: 'transparent', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ width: '100%' }}>
                        <Typography className='fadeInLeftToRight' variant="code" fontSize='2.5rem' fontFamily='PT Mono' color='white' align="flex-start">
                            Technology That Delivers Results
                        </Typography>
                        <Typography sx={{ mt: 1, color: 'rgba(255, 255, 255, 0.85)', maxWidth: '820px', fontFamily: 'Work Sans, sans-serif', lineHeight: 1.6 }}>
                            Full-stack web development, custom software, IoT solutions, brand design, and media production built to grow your business. We use proven tools to ship fast, scalable projects for companies across the UK, Romania, and beyond.
                        </Typography>
                    </Box>
                    <Box sx={{ height: '50px' }} />
                    <Box sx={{
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
                        gap: 3,
                    }}>
                        {capabilityGroups.map((group) => (
                            <Button
                                key={group.title}
                                variant="outlined"
                                onClick={() => this.handleCapabilityClick(group)}
                                sx={{
                                    borderColor: 'rgba(255, 255, 255, 0.5)',
                                    borderRadius: '18px',
                                    p: 2.5,
                                    bgcolor: 'rgba(0, 0, 0, 0.35)',
                                    minHeight: '200px',
                                    textTransform: 'none',
                                    color: 'white',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    textAlign: 'left',
                                    '&:hover': {
                                        borderColor: 'white',
                                        bgcolor: 'rgba(0, 0, 0, 0.5)',
                                    },
                                }}
                            >
                                <Box sx={{ width: '100%' }}>
                                    <Typography sx={{ color: 'white', fontFamily: 'Work Sans, sans-serif', fontWeight: 600 }}>
                                        {group.title}
                                    </Typography>
                                    <Box component="ul" sx={{ mt: 1.5, mb: 0, pl: 2.5, color: 'rgba(255, 255, 255, 0.8)', fontFamily: 'Work Sans, sans-serif', lineHeight: 1.7 }}>
                                        {group.items.map((item) => (
                                            <Box component="li" key={item}>
                                                {item}
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Button>
                        ))}
                    </Box>
                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            href="/contact"
                            sx={{
                                bgcolor: 'white',
                                color: 'black',
                                fontFamily: 'PT Mono, monospace',
                                fontWeight: 'bold',
                                borderRadius: '10px',
                                '&:hover': { bgcolor: 'white', opacity: 0.9 },
                            }}
                        >
                            START A PROJECT
                        </Button>
                        <Button
                            variant="outlined"
                            href="/services"
                            sx={{
                                color: 'white',
                                borderColor: 'white',
                                fontFamily: 'PT Mono, monospace',
                                fontWeight: 'bold',
                                borderRadius: '10px',
                                '&:hover': { borderColor: 'white', opacity: 0.9 },
                            }}
                        >
                            SEE CAPABILITIES
                        </Button>
                    </Box>

                </Container>
            </FadeInSection>
        )
    }
}

export default withRouter(TechComponent);
